export default "/fonts/Flaticon2.woff?76f38df3aea1a621f8bf1ae415a0311d";